<template>
    <Card class="simInfo-card">
        <div class="header">
            <div class="sim-info">
                <div>{{ deviceTitle }}</div>
            </div>
            <ReoCommonButton
                :label="$t('homepage.cloud_library')"
                to="/user/cloud-library"
                color-type="light"
                size="small"
                class="btn"
            />
        </div>
        <ul class="detail" v-show="showItems.more">
            <li>
                <ReoDescription
                    :title="$t('selectProduct.model')"
                    :content="deviceInfo.model.title"
                />
            </li>
            <li>
                <ReoDescription
                    :title="$t('selectProduct.uid')"
                    :content="deviceInfo.uid"
                    desensitize
                />
            </li>
        </ul>
        <ShowMoreButton
            v-model="showItems.more"
        />
        <ReoDialog
            v-if="false"
        />
    </Card>
</template>

<script lang="ts">
import Card from '@/basic/Card.vue';
import ReoDialog from '@/basic/Dialog.vue';
import ShowMoreButton from '@/components/ShowMoreButton.vue';
import { IReolinkDevice } from '@reolink-cloud/interface';
import ImgSimCard from 'IMAGE/dashboard/simCard.png';
import Vue, { PropType } from 'vue';
import ReoDescription from './components/ReoDescription.vue';

export default Vue.extend({
    props: {
        deviceInfo: Object as PropType<IReolinkDevice>
    },
    components: {
        Card,
        ShowMoreButton,
        ReoDescription,
        ReoDialog,
    },
    data() {

        return {
            ImgSimCard,
            showItems: {
                dialog: {
                    confirmUnbind: false,
                    unbindSuccess: false
                },
                more: false,
                inputPaypal: false,
                iccid: false
            },
        };

    },
    computed: {
        deviceTitle(): string {

            if ( this.deviceInfo.title !== '' ) {

                return this.deviceInfo.title;

            }
            return this.deviceInfo.model.title;

        },
    },
    methods: {}
});
</script>

<style lang="less" scoped>
.simInfo-card {
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .sim-info {
            display: flex;
            gap: 12px;
            align-items: center;
            font-size: 20px;
            font-weight: 600;
            color: @font_primary;
            flex-shrink: 1;
            flex-grow: 0;
            min-width: 0;
            white-space: wrap;
            & > div{
                width: 100%;
            }
        }
    }

    ul.detail {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 12px;
    }

}
</style>
